/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  CashCommodityResponseResponse,
  ForbiddenResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get cash commodity with latest declarations, total variance, and progress value. This api will integrate to view cash commodity on Balance Period and Trading Period
 * @summary Get cash commodity with latest declarations, total variance, and progress value.
 */
export const cashCommodity = (declarationType: 'BP' | 'TP', signal?: AbortSignal) => {
  return customInstance<CashCommodityResponseResponse>({
    url: `/bm-declaration-service/v1/commodity/cash/${declarationType}`,
    method: 'get',
    signal,
  });
};

export const getCashCommodityQueryKey = (declarationType: 'BP' | 'TP') => {
  return [`/bm-declaration-service/v1/commodity/cash/${declarationType}`] as const;
};

export const getCashCommodityQueryOptions = <
  TData = Awaited<ReturnType<typeof cashCommodity>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  declarationType: 'BP' | 'TP',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof cashCommodity>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCashCommodityQueryKey(declarationType);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof cashCommodity>>> = ({ signal }) =>
    cashCommodity(declarationType, signal);

  return { queryKey, queryFn, enabled: !!declarationType, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof cashCommodity>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CashCommodityQueryResult = NonNullable<Awaited<ReturnType<typeof cashCommodity>>>;
export type CashCommodityQueryError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Get cash commodity with latest declarations, total variance, and progress value.
 */
export const useCashCommodity = <
  TData = Awaited<ReturnType<typeof cashCommodity>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  declarationType: 'BP' | 'TP',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof cashCommodity>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCashCommodityQueryOptions(declarationType, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
